import { useEffect, useState } from 'react'
import FireworksLayer from './FireworksLayer'
import * as styles from '@/components/organisms/Learning/LearningSytle.css'
import aalpacaImg from '@/assets/img/alpaca.png'
import aalpacaSmileImg from '@/assets/img/alpaca_smlie.png'

interface FlipCardProps {
  flipStatus: 'idle' | 'success' | 'fail'
  front: React.ReactNode
  className?: string,
  messageClassName?: string // 👈 추가
}

const successMessages = [
  '우와~ 정답이야! 진짜 잘했어!',
  '역시 우리 친구~ 대단한걸?',
  '똑똑한데? 이건 완전 알파카 천재!',
  '오오~ 눈썰미 최고다! 완전 정답!',
  '이렇게 멋지게 맞춰버린다고~?',
  '뿌듯~ 알파카가 다 기뻐진다!',
  '정답! 점점 고수가 되어가고 있어~',
  '이야~ 박수 짝짝! 완전 멋져~',
  '이 실력이면 영어왕 되는건 시간문제다~',
  '오늘도 한 건 했네~ 자랑해도 돼 완전!',
]

const failMessages = [
  '조금 다르게 생각했구나! 다시 한 번 해볼까?',
  '괜찮아~ 틀릴 수도 있지. 우리 다시 도전해보자!',
  '이번엔 아쉽지만, 다음엔 꼭 맞출 수 있을 거야.',
  '실수는 배움의 친구야. 이제 더 잘할 수 있겠지?',
  '정답이 아니어도 괜찮아. 시도한 것만으로도 멋졌어!',
  '이번엔 틀렸지만, 네 생각을 들을 수 있어 좋았어~',
  '괜찮아. 한 걸음 더 배운 거니까!',
  '다시 생각해보면 분명히 맞출 수 있어. 같이 해볼까?',
  '정답보다 더 소중한 건, 네가 포기하지 않는 마음이야.',
  '실패는 늘 멋진 시작이야. 우리 다시 시작해보자!',
]

export default function FlipCard({ flipStatus, front, className,messageClassName }: FlipCardProps) {
  const [message, setMessage] = useState('')
  const [showBackContent, setShowBackContent] = useState(false)
  const [currentImage, setCurrentImage] = useState<string | null>(null)

  useEffect(() => {
    let timeout: NodeJS.Timeout

    if (flipStatus === 'success') {
      setMessage(successMessages[Math.floor(Math.random() * successMessages.length)])
      setCurrentImage(aalpacaSmileImg)
      setShowBackContent(true)
    } else if (flipStatus === 'fail') {
      setMessage(failMessages[Math.floor(Math.random() * failMessages.length)])
      setCurrentImage(aalpacaImg)
      setShowBackContent(true)
    } else {
      // idle 상태로 전환 → 이미지와 메시지를 약간 delay 후 제거
      timeout = setTimeout(() => {
        setShowBackContent(false)
        setMessage('')
        setCurrentImage(null)
      }, 800) // 카드가 회전 끝난 시점에
    }

    return () => clearTimeout(timeout)
  }, [flipStatus])

  return (
    <div
      className={className ? `${styles.flipCard} ${className}` : styles.flipCard}
      style={{
        transform: flipStatus !== 'idle' ? 'rotateX(180deg)' : 'rotateX(0deg)',
      }}
    >
      <div className={styles.cardFaceFront}>{front}</div>

      <div
        className={styles.cardFaceBack}
        style={{
          backgroundColor:
            flipStatus === 'success'
              ? '#2CC18F'
              : flipStatus === 'fail'
              ? '#F95567'
              : '#fff',
          transition: 'background-color 0.8s ease',
        }}
      >
        <div
          className="flex relative flex-col gap-5 justify-center items-center w-full h-full text-center text-white transition-opacity duration-500 lg:justify-start lg:items-end lg:flex-row lg:gap-5"
          style={{
            opacity: showBackContent ? 1 : 0,
            pointerEvents: showBackContent ? 'auto' : 'none',
          }}
        >
          <img
            src={currentImage || aalpacaImg}
            alt="alpaca"
            className="w-full max-w-[100px] lg:max-w-[180px] max-h-[calc(100%-20px)] object-contain"
            style={{
              visibility: currentImage ? 'visible' : 'hidden',
              transition: 'visibility 0.3s ease',
            }}
          />
          <p className={`z-10 px-5 flex items-center justify-center w-full text-lg font-bold leading-snug whitespace-pre-wrap lg:text-[20px] lg:h-full text-center ${messageClassName ?? ''}`}>
            {message}
          </p>
        </div>
      </div>

      {flipStatus === 'success' && <FireworksLayer />}
    </div>
  )
}